import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface GetCENSMEDashboardDetailsApiParameter extends ApiParameter {}

export interface SMEPersonModel {
    id: string;
    fullName: string;
    title: string;
    branchName: string;
    bioSnippet: string;
    startDate: string;
    photoUrl: string | null;
}

// ADD these two new interfaces:
export interface SMEExpertiseSpotlightDetail {
    id: string;
    fullName: string;
    photoUrl: string | null;
}

export interface SMEExpertiseSpotlightModel {
    expertiseId: string;
    expertiseName: string;
    source: string;
    smeDetails: SMEExpertiseSpotlightDetail[];
}

export interface CENSMEDashboardDetailsModel {
    expertiseSpotlight: SMEExpertiseSpotlightModel[] | null; // ONLY this line changes
    recentlyJoined: SMEPersonModel[];
    meetYourCoworker: SMEPersonModel[];
    properties: Record<string, unknown>;
}

const cenSMEDashboardDetailsApiUrl = "/api/v2/centroconnect/sme";

export function getCENSMEDashboardDetails(parameter?: GetCENSMEDashboardDetailsApiParameter) {
    return get<CENSMEDashboardDetailsModel>(cenSMEDashboardDetailsApiUrl, parameter);
}
